import styled from "@emotion/styled";

export const UserSettingsContainer = styled.div(({ theme }) => ({
	display: "flex",
	padding: "20px 32px",
	flexDirection: "column",
	backgroundColor: theme.project.colors.backgroundColors.main,
	color: theme.project.colors.fontColors.secondary,
	gap: "8px",
	"& > div:first-of-type": {
		...theme.project.typography.subtitle.subtitle1
	}
}));
